import styled from 'styled-components';
import tw from 'twin.macro';

export const GoBackContainer = styled.button`
  ${tw`flex justify-center items-center cursor-pointer self-start font-inter pb-6`};

  * {
    pointer-events: none;
  }
`;

export const GoBackText = styled.span`
  ${tw`font-inter text-sm leading-5 font-normal ml-1 text-lightBlueGray`};
`;
